import React from "react";

import { isAuthenticated } from "./auth";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import Task from "./views/Task/Task";
import TaskAll from "./views/Task/TaskAll";
import TaskDescriptions from "./views/TaskDescriptions/TaskDescriptions";
import Memorial from "./views/Memorial/Memorial";
import CheckList from "./views/Frota/CheckList.js";
import Equipaments from "./views/Equipaments/Equipaments";
import ActivityPOP from "./views/Activity/ActivityPOP";
import ActivityClient from "./views/Activity/ActivityClient";
import ActivityClientNoEdit from "./views/Activity/ActivityClientNoEdit";
import ActivityAll from "./views/Activity/ActivityAll";
import FormClient from "./views/FormClient/FormClient";
import Login from "./views/Login/Login";
//import { createGroup } from "./push-notification";
import TaskHistory from "./views/TaskHistory/TaskHistory";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery";

import "bootstrap/dist/js/bootstrap.bundle.min";

import { library } from "@fortawesome/fontawesome-svg-core";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStroopwafel } from "@fortawesome/free-solid-svg-icons";

library.add(faStroopwafel);
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    }
  />
);

function Rota() {
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route path="/login" exact={true} component={Login} />
          <PrivateRoute path="/" exact={true} component={Task} />
          <PrivateRoute path="/task" component={Task} />
          <PrivateRoute path="/taskAll" component={TaskAll} />
          <PrivateRoute
            path="/task-descriptions/:id"
            component={TaskDescriptions}
          />
           <PrivateRoute
            path="/taskhistory"
            component={TaskHistory}
          />
          <PrivateRoute path="/memorial/:id/:idMemorial" component={Memorial} />
          <PrivateRoute path="/check-list" component={CheckList} />
          <PrivateRoute path="/equipaments/:id" component={Equipaments} />
          <PrivateRoute path="/activity-pop/:id" component={ActivityPOP} />

          <PrivateRoute
            path="/activity-client/:id"
            component={ActivityClient}
          />

          <PrivateRoute
            path="/activity-client-history/:id"
            component={ActivityClientNoEdit}
          />

          <PrivateRoute
            path="/form-client/:id/:idFormulario"
            component={FormClient}
          />

          <PrivateRoute path="/activity-all/:id" component={ActivityAll} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default Rota;
